import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    render_checkCameraFeature: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER]),
      default: () => false,
    },
    render_viewonly: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    render_isdisabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_wlId: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    render_nextMaintenanceDate: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_deviceType: {
      [SERVICE_PROVIDERS.PATRIOT]: () => [{ label: 'Tracking', value: 'Tracking' }],
      default: () => [],
    },
    render_mechanics: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      [SERVICE_PROVIDERS.NAUTO]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      [SERVICE_PROVIDERS.TWOBRO]: () => false,
      default: () => true,
    },
    render_drivers: {
      [SERVICE_PROVIDERS.SIMPLEX]: () => false,
      default: () => true,
    },
    render_dept: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_radiusCompliance: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
